import moment from 'moment';
import { BookingSharingAvailability, BookingSharingRequest } from 'types/BookingSharing';

const getAvailabilityNonTakenSlots = (
    availability: Pick<BookingSharingAvailability, 'start_at' | 'end_at' | 'assigned_requests'>,
    assignedRequests: BookingSharingRequest[],
) => {
    if (availability.assigned_requests.length === 0 || assignedRequests.length === 0) {
        return [
            {
                start: new Date(availability.start_at),
                end: new Date(availability.end_at),
            },
        ];
    }

    // Sort assigned requests by start time
    const sortedRequests = assignedRequests
        .map((request) => ({ ...request, start_at: new Date(request.start_at), end_at: new Date(request.end_at) }))
        .sort((a, b) => a.start_at.getTime() - b.start_at.getTime());

    // Calculate available slots
    const availableSlots: Array<{ start: Date; end: Date }> = [];

    // Check if there's time before the first booking
    if (sortedRequests[0].start_at > new Date(availability.start_at)) {
        availableSlots.push({
            start: new Date(availability.start_at),
            end: sortedRequests[0].start_at,
        });
    }

    // Check for gaps between bookings
    for (let i = 0; i < sortedRequests.length - 1; i++) {
        const currentEnd = sortedRequests[i].end_at;
        const nextStart = sortedRequests[i + 1].start_at;

        // If the gap is greater than 5 minutes, add it to the available slots
        if (currentEnd < nextStart && moment(currentEnd).diff(moment(availability.end_at), 'minutes', true) > 5) {
            availableSlots.push({
                start: currentEnd,
                end: nextStart,
            });
        }
    }

    // Check if there's time after the last booking
    const lastBooking = sortedRequests[sortedRequests.length - 1];
    if (lastBooking.end_at < new Date(availability.end_at)) {
        availableSlots.push({
            start: lastBooking.end_at,
            end: new Date(availability.end_at),
        });
    }
    return availableSlots;
};

export default getAvailabilityNonTakenSlots;
